import {
  featureConfig,
  featureFlags,
} from "shell/platform/config/featureFlags";

type AmplitudeModule = typeof import("./amplitude");

let modulePromise: Promise<AmplitudeModule | null> | null = null;

/**
 * Amplitude only runs in the console build, when the flag is on and a key is
 * set. The standalone sandbox build has its own integration.
 */
export const isAmplitudeEnabled = () =>
  featureFlags.enableAmplitude &&
  Boolean(featureConfig.amplitudeApiKey) &&
  import.meta.env.VITE_BUILD_TARGET !== "sandbox";

/**
 * Lazily loads the Amplitude module so the SDK stays out of the entry bundle.
 * Returns null when the feature is off, and resolves to null if the import
 * fails, so callers never need their own error handling.
 */
export const loadAmplitude = (): Promise<AmplitudeModule | null> | null => {
  if (!isAmplitudeEnabled()) return null;

  modulePromise ??= import("./amplitude").catch(error => {
    modulePromise = null;
    console.warn("Failed to load Amplitude", error);
    return null;
  });

  return modulePromise;
};
